import React from 'react';
import { Button, Box } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

export interface SherlockInvestigateButtonProps {
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
}

export const SherlockInvestigateButton: React.FC<SherlockInvestigateButtonProps> = ({
  onClick,
  disabled = false,
  loading = false,
}) => {
  return (
    <Button
      variant="outlined"
      startIcon={
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Box
            component="img"
            src="/sherlock-logo.png"
            alt="Sherlock"
            sx={{ width: '1.2rem', height: '1.2rem' }}
          />
        </Box>
      }
      onClick={onClick}
      disabled={disabled || loading}
    >
      Launch Sherlock
    </Button>
  );
};
